// extracted by mini-css-extract-plugin
export default {"serviceItem":"Service_serviceItem__ZmWsZ","figure":"Service_figure__unuS7","content":"Service_content__F5hBv","service":"Service_service__HtsxY"};